<div class="area-maxima">
    <div class="titulo-pagina">Confeccionar LUDs</div>
    <div class="area-ato">
        <div class="form-group info-superior">
            <span *ngIf="carregandoSegmentos">
                Carregando segmentos: {{ segmentosCarregados }}/{{ segmentos.length }}
            </span>
            <span *ngIf="!carregandoSegmentos">
                Segmentos carregados: {{ segmentosCarregados }}
            </span>
            <div class="botoes-superiores">
                <button type="button btn-sm" class="btn btn-default"
                    [title]="carregandoSegmentos ? 'Aguarde até que todos os segmentos sejam carregados' : 'Iniciar Confeccionar LUDs'"
                    (click)="localizarEConfeccionarLuds()" [disabled]="carregandoSegmentos">
                    Confeccionar LUDs
                </button>
                <button type="button btn-sm" class="btn btn-default"
                    [title]="carregandoSegmentos ? 'Aguarde até que todos os segmentos sejam carregados' : 'Próximo LUD'" (click)="navegarProximoLud()"
                    [disabled]="carregandoSegmentos">
                    Navegar <em class="material-icons icon-18">navigate_next</em>
                </button>
            </div>
        </div>
        <div id="conteudoAto" #conteudoAto class="conteudo-ato" name="conteudo-ato">
            <div [id]="'segmentoLud'+idx"
                    *ngFor="let segmento of segmentos; let idx = index"
                    [style]="segmento.idTipoSegmento === 1 ? {width: '75%', float: 'right', clear: 'right'} : {width: '100%', clear: 'right'}">
                <div class="segmento2" [style.borderWidth]="'1px'" [style]="segmento.style" *ngIf="segmento.idTipoSegmento !== 16 && !segmento.visivel && segmento.fresh">
                        <span [innerHTML]="segmento.textoIntegra"></span>
                </div>
                <div [style.borderWidth]="'1px'" *ngIf="segmento.idTipoSegmento !== 16 && (segmento.visivel || !segmento.fresh)">
                    <quill-editor
                        placeholder=""
                        [readOnly]="true"
                        [class]="'segmento'"
                        [styles]="segmento.style"
                        [style.width]="'100%'"
                        [(ngModel)]="segmento.textoIntegra"
                        [modules]="{ toolbar: false }"
                        (onEditorCreated)="quillOnEditorCreated($event, idx)"
                        (mousedown)="quillOnMouseDown()"
                        (mouseup)="quillOnMouseUp(idx)">
                    </quill-editor>
                </div>
                <div *ngIf="segmento.idTipoSegmento === 16" class="anexo">
                    <div class="anexo-ancora" [style]="segmento.style">
                        <em class="material-icons icon-18">file_present</em> {{ segmento.textoIntegra }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group botoes">
            <button type="button" class="btn btn-default" title="Cancelar edições" (click)="cancelarEdicoes()">
                Cancelar edições
            </button>
            <button type="button" class="btn btn-primary" title="Confirmar edições" (click)="confirmarEdicoes()">
                Confirmar edições
            </button>
        </div>
    </div>

    <div class="area-gestao">
        <div class="painel-area-gestao">

            <!-- <div *ngFor="let s of segmentos" [style.color]="s.visivel?'black':'gray'">
                <span>{{ s.textoIntegra.substring(0,1000) }}</span>
            </div> -->

            <app-painel-luds
                    [bancoRecursos]="bancoRecursos"
                    [ludSelecionado]="ludSelecionado"
                    (ludConfirmado)="confeccionarLudDoPainel($event)">
            </app-painel-luds>
        </div>
    </div>

</div>